import moment from "moment"
import { window } from "global"
import React from "react"
import { Typography, Tooltip } from "@mui/material"

// Get Mobile device operating system
export function getMobileWebOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  if (/android/i.test(userAgent)) {
    return "android"
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "ios"
  }

  return ""
}

// returns a negative number for furtureDates that have already passed
export const daysUntil = (futureDate, currentDate) => {
  if (currentDate) {
    return moment(futureDate).diff(moment(currentDate, "days")) + 1
  }
  return moment(futureDate).diff(moment(), "days") + 1
}

// Get browser operating system
export const getWebOS = () => {
  if (navigator?.platform && navigator?.platform?.indexOf("iPhone") !== -1) return "ios"
  return "android"
}

const monthsArray = [
  "Jan",
  "Feb",
  "March",
  "April",
  "May",
  "June",
  "July",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
]

export const getMonthName = (dateObj) => {
  return monthsArray[dateObj.getMonth()]
}

export const getMonthNameFromString = (string) => {
  return monthsArray[string]
}

export const getMonthYearString = (string) => {
  const dateArr = string ? string.split("-") : ""
  return `${monthsArray[parseInt(dateArr[1]) - 1]} ${dateArr[0]}`
}

export const getMonthYearFromDate = (dateObj) => {
  return moment(dateObj).format("MMM YYYY")
}

export const getFormattedDate = (dateString = "") => {
  let answer = dateString.split("-").reverse()
  if (answer.length < 3) {
    return "-"
  }
  const months = {
    "01": "Jan",
    "02": "Feb",
    "03": "Mar",
    "04": "Apr",
    "05": "May",
    "06": "Jun",
    "07": "Jul",
    "08": "Aug",
    "09": "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec"
  }

  answer[1] = months[answer[1]]

  return answer.join(" ")
}

export const formatDate = (dateObj) => {
  return moment(dateObj).format("YYYY-MM-DD")
}

export const dateDiffInDays = (date1, date2) => {
  const diffTime = date2 - date1
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
}

export const bytesToSize = (bytes) => {
  var sizes = ["Bytes", "KB", "MB", "GB", "TB"]
  if (bytes == 0) return "0 Byte"
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
  return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i]
}

export const removeDecimalUpto1 = (value) => {
  value *= 10
  let newValue = parseInt(value)
  return newValue / 10
}

export const dateToUTC = (date) => moment(date).utc()

export const getYoutubeIdByUrl = (url) => {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
  const match = url?.match(regExp)

  return match && match[2].length === 11 ? match[2] : null
}

export function toTitleCase(str) {
  return str?.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}

export function getLastDayOfMonth(date) {
  const dateObject = new Date(date)
  const newDate = new Date(dateObject.getFullYear(), dateObject.getMonth() + 1, 0)

  return formatDate(newDate)
}

export const generateMonths = (startDate) => {
  if (!startDate) return []
  const months = []
  const start = new Date(startDate)
  const currentMonth = start.getMonth()
  const lastMonth = currentMonth === 0 ? 11 : currentMonth - 1
  const currentYear = start.getFullYear()
  const lastMonthYear = lastMonth === 11 ? currentYear - 1 : currentYear
  ;[lastMonth, currentMonth].forEach((month, index) => {
    const year = index === 0 ? lastMonthYear : currentYear
    months.push({
      label: new Date(year, month).toLocaleString("default", { month: "long" }),
      value: new Date(year, month + 1, 1).toISOString().split("T")[0] // Fix here
    })
  })
  return months
}

export function splitAndMergeString(data) {
  const newString = data?.split("_")
  return toTitleCase(newString?.join(" "))
}

export const isEmptyObject = (obj) => {
  if (JSON.stringify(obj) === "{}") {
    return true
  } else {
    return false
  }
}

export const initDateConvert = (date, time) => {
  const initDate = moment(date).format("ddd MMM DD YYYY") + " " + time
  const temp = new Date(initDate)
  const convertedUTCDate = new Date(
    Date.UTC(
      temp.getFullYear(),
      temp.getMonth(),
      temp.getDate(),
      temp.getHours(),
      temp.getMinutes(),
      temp.getSeconds()
    )
  )
  return moment(convertedUTCDate).local().toDate()
}

export const convertDate = (date, time) => {
  const forDate = moment(new Date(date)).format("ddd MMM DD YYYY") + " " + time
  const newDate = new Date(forDate)
  return newDate.toUTCString()
}

export const convertDateToUTC = (date) => {
  const forDate = moment(new Date(date)).format("ddd MMM DD YYYY")
  const newDate = new Date(forDate)
  return newDate.toUTCString()
}

const months = {
  Jan: "01",
  Feb: "02",
  Mar: "03",
  Apr: "04",
  May: "05",
  Jun: "06",
  Jul: "07",
  Aug: "08",
  Sep: "09",
  Oct: "10",
  Nov: "11",
  Dec: "12"
}

export const payloadDate = (dateArray = []) => {
  return `${dateArray[3]}-${months[dateArray[2]]}-${dateArray[1]}`
}

export const desiredMenuOrder = [
  "Dinner",
  "Lunch",
  "Brunch",
  "BreakFast",
  "Bar Menu",
  "Wine By Glass",
  "Wine By Bottle",
  "Spirits"
]

export const formatDateDetail = (condition, date, defaultText) => {
  return condition !== defaultText
    ? `${condition} on ${moment.tz(date, "UTC").local().format("MMM DD, YYYY [at] hh:mm A")}`
    : defaultText
}

export const statusColor = {
  TOP_SERVER: "top-server",
  DOING_GREAT: "doing-great",
  AVERAGE: "average",
  UNDER_PERFORMING: "under-performing",
  POOR: "poor"
}

export const getRankColor = (rowData) => {
  switch (rowData?.performance_status) {
    case statusColor.TOP_SERVER:
      return "#3ADB76"
    case statusColor.DOING_GREAT:
      return "#9CC43B"
    case statusColor.AVERAGE:
      return "#FFAE00"
    case statusColor.UNDER_PERFORMING:
      return "#E67C1B"
    case statusColor.POOR:
      return "#CC4B37"
    default:
      return "#FFFFFF"
  }
}

export const generateWeekRangesForMonth = (year, month) => {
  const monthStart = moment({ year, month }).startOf("month")
  const monthEnd = moment({ year, month }).endOf("month")
  const weeks = []
  let currentWeekStart = monthStart.startOf("week").add(1, "days")
  let weekCounter = 1
  while (currentWeekStart.isBefore(monthEnd) || currentWeekStart.isSame(monthEnd, "week")) {
    const weekEnd = moment(currentWeekStart).add(6, "days")
    weeks.push({
      label: `Week ${weekCounter}`,
      range: `(${currentWeekStart.format("MMM DD")}-${weekEnd.format("MMM DD")})`,
      value: {
        start: currentWeekStart.format("YYYY-MM-DD"),
        end: weekEnd.format("YYYY-MM-DD")
      }
    })
    currentWeekStart = moment(weekEnd).add(1, "days")
    weekCounter++
  }
  return weeks
}

export const trimText = (value, limit) => {
  if (value.length > limit) {
    return `${value.slice(0, limit)}...`
  } else {
    return value
  }
}

export const formatMenuDate = (date) => {
  if (!date) return ""
  // convert date to local time
  const forDate = moment(date).format("ddd MMM DD YYYY")
  const newDate = new Date(forDate)
  const convertedUTCDate = new Date(
    Date.UTC(
      newDate.getFullYear(),
      newDate.getMonth(),
      newDate.getDate(),
      newDate.getHours(),
      newDate.getMinutes(),
      newDate.getSeconds()
    )
  )
  let formattedDate = moment(convertedUTCDate).local().format("MMM DD YYYY")
  return `${formattedDate}`
}

export const capitalize = (s) => {
  if (typeof s !== "string") return ""
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase()
}

export const formatDates = (date) => {
  if (!date) return ""
  const formattedDate = moment(date).format("MMM DD YYYY")
  return formattedDate
}

export const formatNumberToThousand = (num) => {
  return num !== null && num !== undefined && num !== ""
    ? Math.abs(num) >= 1000
      ? `${Math.sign(num) * Math.floor(Math.abs(num) / 1000)},${(Math.abs(num) % 1000)
          .toString()
          .padStart(3, "0")}`
      : num
    : num
}

export const convertTo12HourFormat = (time) => {
  if (!time) return ""

  const [hours, minutes] = time.split(":").map(Number)
  const period = hours >= 12 ? "PM" : "AM"
  const hours12 = hours % 12 || 12

  return `${hours12}:${String(minutes).padStart(2, "0")} ${period}`
}

export const convertDates = (date) => {
  return date
    .toLocaleDateString("en-US", { day: "numeric", month: "long" })
    .replace(/(\d{1,2})/, (match) => {
      if (match.endsWith("1") && match !== "11") return `${match}st`
      if (match.endsWith("2") && match !== "12") return `${match}nd`
      if (match.endsWith("3") && match !== "13") return `${match}rd`
      return `${match}th`
    })
}

export const getDaysInMonth = (year, month) => {
  return new Date(year, month + 1, 0).getDate()
}

export const formatMonthYear = (date) => {
  return date?.toLocaleDateString("en-US", { year: "numeric", month: "long" })
}

export const isInRange = (dateStr, startDate, endDate) => {
  if (!startDate || !endDate) return false

  const date = new Date(dateStr)
  const start = new Date(startDate)
  const end = new Date(endDate)

  const minDate = start <= end ? start : end
  const maxDate = start <= end ? end : start

  return date >= minDate && date <= maxDate
}

export const isInHoverRange = (dateStr, selectionMode, startDate, hoverDate) => {
  if (!startDate || !hoverDate || selectionMode !== "end") return false

  const date = new Date(dateStr)
  const start = new Date(startDate)
  const hover = new Date(hoverDate)

  const minDate = start <= hover ? start : hover
  const maxDate = start <= hover ? hover : start

  return date >= minDate && date <= maxDate
}

export const isFutureDate = (dateStr) => {
  const today = new Date()
  const date = new Date(dateStr)
  today.setHours(0, 0, 0, 0)
  date.setHours(0, 0, 0, 0)
  return date > today
}

export const handleTimeChange = (e, field, formik) => {
  const value = e?.target ? e.target.value : e
  formik?.setFieldValue(field, value)
}

export const weekdaysData = {
  Monday: {
    checked: false,
    open: "",
    close: ""
  },
  Tuesday: {
    checked: false,
    open: "",
    close: ""
  },
  Wednesday: {
    checked: false,
    open: "",
    close: ""
  },
  Thursday: {
    checked: false,
    open: "",
    close: ""
  },
  Friday: {
    checked: false,
    open: "",
    close: ""
  },
  Saturday: {
    checked: false,
    open: "",
    close: ""
  },
  Sunday: {
    checked: false,
    open: "",
    close: ""
  }
}

export const hoursOfOpenrationEnum = {
  heading: "",
  open: "",
  close: ""
}

export const getComponentType = (label) => {
  switch (label) {
    case "name":
    case "category":
    case "item_state":
    case "service_details":
    case "sourcing":
    case "modifications":
      return "textField"
    case "allergance":
    case "menu_description":
    case "allergens":
    case "ice":
    case "tasting_notes":
      return "autoComplete"
    case "image":
      return "imageUpload"
    case "item_price":
    case "price":
      return "numberField"
    case "unique_facts":
    case "glossary":
      return "uniqueFact"
    case "notification_date":
      return "datePicker"
    case "notification_time":
      return "timeField"
    case "description":
    case "bar_recipe":
    case "history":
    case "bar_prep":
    case "sound_bite":
      return "textArea"
    case "ingredients":
      return "ingredients"
    default:
      return "textField"
  }
}

export const getDidYouKnowPayload = (list = [], didYouKnowImage) =>
  list?.map(({ heading, content, image }, index) => ({
    title: heading,
    description: content,
    image_id: didYouKnowImage?.[index] || image?.id || ""
  }))

export const getHistoryPayload = (history = {}) => ({
  title: history?.heading || "",
  description: history?.content || ""
})

export function getMonthWithOffset(offset = 0) {
  const now = new Date()
  const date = new Date(now.getFullYear(), now.getMonth() + offset, 1)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, "0")
  return `${year}-${month}`
}

export function formateString(data) {
  const newString = data?.split(" ")
  return newString?.join("_")
}

export const searchHotelServices = (data, query) => {
  if (!query) return data
  const lowerQuery = query.toLowerCase()

  return data
    .map((section) => {
      const filteredItems = section?.items?.filter((item) => {
        const inName = item?.name?.toLowerCase()?.includes(lowerQuery)
        const inDescription = item?.description?.toLowerCase()?.includes(lowerQuery)

        const inDynamicFields = item?.dynamic_fields?.some((field) => {
          if (Array.isArray(field?.value)) {
            return field?.value.some((subField) => {
              return (
                typeof subField?.value === "string" &&
                subField.value.toLowerCase().includes(lowerQuery)
              )
            })
          } else if (typeof field?.value === "string") {
            return field.value.toLowerCase().includes(lowerQuery)
          }
          return false
        })

        return inName || inDescription || inDynamicFields
      })

      return {
        ...section,
        items: filteredItems
      }
    })
    .filter((section) => section?.items?.length > 0)
}

export const highlightText = (text, searchedText) => {
  if (!searchedText) return text
  if (typeof text !== "string") return text

  const escapeRegex = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  const regex = new RegExp(`(${escapeRegex(searchedText)})`, "gi")

  const parts = text.split(regex)

  return parts.map((part, index) =>
    part.toLowerCase() === searchedText.toLowerCase() ? (
      <span key={index} style={{ backgroundColor: "#a2a217", fontWeight: 500 }}>
        {part}
      </span>
    ) : (
      part
    )
  )
}

export const formatListWithTooltip = (list = [], theme, displayCount = 3) => {
  if (!list || list.length === 0) return "-"

  const displayList = list.slice(0, displayCount)
  const remainingRemaining = list.length - displayCount

  if (remainingRemaining > 0) {
    return (
      <Typography variant="body1Regular">
        {displayList.join(", ")}
        <Tooltip title={list.slice(displayCount).join(", ")}>
          <span style={{ color: theme.palette.secondary.main, cursor: "pointer" }}>
            {" "}
            +{remainingRemaining} More
          </span>
        </Tooltip>
      </Typography>
    )
  }

  return displayList.join(", ")
}

export const formatTime = (date, time) => {
  if (!date || !time) return ""
  // convert time to local time
  const initDate = moment(date).format("ddd MMM DD YYYY") + " " + time
  const temp = new Date(initDate)
  const convertedUTCTime = new Date(
    Date.UTC(
      temp.getFullYear(),
      temp.getMonth(),
      temp.getDate(),
      temp.getHours(),
      temp.getMinutes(),
      temp.getSeconds()
    )
  )
  let formatedTime = moment(convertedUTCTime).local().format("hh:mm A")
  // convert date to local time
  const forDate = moment(date).format("ddd MMM DD YYYY") + " " + time
  const newDate = new Date(forDate)
  const convertedUTCDate = new Date(
    Date.UTC(
      newDate.getFullYear(),
      newDate.getMonth(),
      newDate.getDate(),
      newDate.getHours(),
      newDate.getMinutes(),
      newDate.getSeconds()
    )
  )
  let formattedDate = moment(convertedUTCDate).local().format("MMM DD YYYY")
  return `${formattedDate} at ${formatedTime}`
}

export const unlockLogicLabel = (val) => {
  const map = { coinsOnly: "Coins", streakOnly: "Streak", coinsAndStreak: "Streak or coins" }
  return map[val] || val
}
